import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';
@Injectable()
export class PmService {

    constructor(
        private httpService: HttpService
    ) { }
    /**
     * 登录DB真人
     */
    loginPm() {
        let url = AppConfig.GetProdUrl() + "/PmReal/Login";
        return this.httpService.post(url, { Device: 2 });
    }
    //获取DB真人余额
    getPmBalance() {
        let url = AppConfig.GetProdUrl() + "/PmReal/GetBalance";
        return this.httpService.post(url, {});
    }
    /**
     * 平台转账到DB真人
     */
    transferToPm(money: number) {
        let url = AppConfig.GetProdUrl() + "/PmReal/TransferToPmReal";
        return this.httpService.post(url, { Amount: money, Type: "0" });
    }
    /**
   * @params DB真人转到平台
   */
    transferFromPm(money: number) {
        let url = AppConfig.GetProdUrl() + "/PmReal/TransferFromPmReal";
        return this.httpService.post(url, { Amount: money, Type: "1" });
    }





    /**
 * 登录bg真人
 */
    loginBg() {
        let url = AppConfig.GetProdUrl() + "/Bg/Login";
        return this.httpService.post(url, { Device: 2 });
    }
    //获取bg真人余额
    getBgBalance() {
        let url = AppConfig.GetProdUrl() + "/Bg/GetBalance";
        return this.httpService.post(url, {});
    }
    /**
     * 平台转账到bg真人
     */
    transferToBg(money: number) {
        let url = AppConfig.GetProdUrl() + "/Bg/TransferToBg";
        return this.httpService.post(url, { Money: money, Type: "0" });
    }
    /**
   * @params bg真人转到平台
   */
    transferFromBg(money: number) {
        let url = AppConfig.GetProdUrl() + "/Bg/TransferFromBg";
        return this.httpService.post(url, { Money: money, Type: "1" });
    }

}



// WEBPACK FOOTER //
// ./src/services/pm.service.ts